import React from 'react'
import useForm from 'react-hook-form'
import useSnackbar from 'hooks/useSnackbar'

import {
  Button,
  Dialog,
  Divider,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Typography,
} from '@material-ui/core'

import schemas from '../../schemas'

import * as service from 'service'

const DialogInvoiceReverse = ({
  open,
  setOpen,
  invoiceId,
  onLoading = () => {},
  onEvent = () => {},
}) => {
  const { handleSubmit, register, errors } = useForm({
    validationSchema: schemas.observationSchema,
  })
  const snackbar = useSnackbar()

  const onSubmit = async reverse => {
    onLoading(true)
    try {
      await service.recurrence.invoices.reverse({
        invoiceId,
        observation: reverse.observation,
      })

      snackbar.open({
        message: 'Pagamento estornado com sucesso!',
        variant: 'success',
      })
      setOpen(false)
      onEvent(true)
      onLoading(false)
    } catch (error) {
      onLoading(false)
      setOpen(false)
      snackbar.open({
        message: `Falha ao estornar o pagamento! ${error.response.data.error.message}`,
        variant: 'error',
      })
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle id="form-dialog-title">
        <div>
          <Typography variant="h3">Estornar fatura</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText align="justify">
          Atenção: Ao realizar um estorno, o pagamento da fatura em questão será
          revertido. Após confirmar o estorno ele não poderá ser desfeito. Caso
          esta fatura possua alguma nota fiscal gerada nos útlimos 30 dias a
          mesma será cancelada.
        </DialogContentText>
        <form id="reverse-form" onSubmit={handleSubmit(onSubmit)}>
          <TextField
            autoFocus
            name="observation"
            margin="dense"
            label="Motivo do estorno"
            inputRef={register}
            error={errors.observation !== undefined}
            helperText={errors.observation ? errors.observation.message : ''}
            fullWidth
          />
        </form>
      </DialogContent>
      <Divider />
      <DialogActions p={2}>
        <Button
          variant="contained"
          color="primary"
          form="reverse-form"
          type="submit"
        >
          Confirmar
        </Button>
        <Button
          onClick={() => setOpen(false)}
          variant="outlined"
          color="primary"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogInvoiceReverse
